import React, { useState, useEffect } from 'react';

const NoInternet = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    if (isOnline) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center overflow-hidden">
            {/* Blurred Backdrop */}
            <div className="absolute inset-0 bg-black/40 backdrop-blur-md transition-all duration-500"></div>

            {/* Content Card */}
            <div className="relative bg-gray-900/90 border border-white/10 p-8 rounded-3xl shadow-2xl max-w-sm w-full mx-4 text-center transform scale-in opacity-in animate-in fade-in zoom-in duration-300">
                <div className="mb-6 relative">
                    <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto animate-pulse">
                        <i className="ri-wifi-off-line text-red-500 text-4xl"></i>
                    </div>
                </div>

                <h2 className="text-2xl font-black text-white mb-2 tracking-tight">No Connection</h2>
                <p className="text-gray-400 text-sm leading-relaxed mb-8">
                    It looks like you've been disconnected. Please check your internet connection to continue using FF Arena.
                </p>

                <div className="space-y-3">
                    <button
                        onClick={() => window.location.reload()}
                        className="w-full bg-gradient-to-r from-red-600 to-red-500 text-white py-3.5 rounded-xl font-bold text-sm shadow-lg shadow-red-500/20 hover:shadow-red-500/40 transition-all active:scale-95 flex items-center justify-center space-x-2"
                    >
                        <i className="ri-refresh-line"></i>
                        <span>Try Reconnecting</span>
                    </button>

                    <p className="text-[10px] uppercase tracking-widest text-gray-600 font-bold">
                        Auto-reconnecting when online...
                    </p>
                </div>
            </div>

            <style>{`
                @keyframes scale-pulse {
                    0%, 100% { transform: scale(1); }
                    50% { transform: scale(1.05); }
                }
            `}</style>
        </div>
    );
};

export default NoInternet;
